module.exports = ".fx-grid-tool-header {\n  float: left;\n  margin: 0 0 0 3px;\n}\n"